import * as momentAlias from 'moment';

export function moment(inp?: momentAlias.MomentInput, format?: momentAlias.MomentFormatSpecification, language?: string, strict?: boolean) {
    return momentAlias(inp, format, language, strict);
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/moment.ts